import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    useToast,
    Text,
} from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { useRef } from 'react';
import { intentionalyFloatingPromiseReturn } from 'utils/wrappers';
import { TInternationalCompanyGroup } from '../useInternationalCompanyGroup';
import { useDeleteInternationalCompanyGroupMutation } from 'core/API/internationalCompanyGroupApi';

interface IDeleteModalProps {
    isDeleteOpen: TInternationalCompanyGroup['isDeleteOpen'];
    onDeleteOpen?: TInternationalCompanyGroup['onDeleteOpen'];
    onDeleteClose: TInternationalCompanyGroup['onDeleteClose'];
    modalData: TInternationalCompanyGroup['modalData'];
}
const DeleteModal = ({ isDeleteOpen, onDeleteClose, modalData }: IDeleteModalProps) => {
    const deleteInitialRef = useRef(null);
    const toast = useToast();
    const translate = useTranslation();
    const [deleteInternationalCompanyGroup, { isLoading: isDeleteInternationalCompanyGroupLoading }] =
        useDeleteInternationalCompanyGroupMutation();
    const handleDeleteProductKeyword = async () => {
        try {
            const resp = await deleteInternationalCompanyGroup({
                internationalCompanyGroupId: modalData.internationalCompanyGroupId,
            } as any);
            if ('error' in resp) {
                throw new Error();
            } else {
                toast({
                    title: translate('icg.modal.delete.success'),
                    status: 'success',
                    isClosable: true,
                });
            }
            onDeleteClose();
        } catch (error) {
            toast({
                title: translate('icg.modal.delete.error', { err: (error as Error).message }),
                status: 'error',
                isClosable: true,
            });
        }
    };

    const handleCloseDelete = () => {
        onDeleteClose();
    };

    return (
        <Modal isCentered initialFocusRef={deleteInitialRef} isOpen={isDeleteOpen} onClose={handleCloseDelete}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader tabIndex={-1} ref={deleteInitialRef}>
                    <Text as="h3">{translate('icg.modal.delete.title')}</Text>
                </ModalHeader>
                <ModalCloseButton mt="2" isDisabled={isDeleteInternationalCompanyGroupLoading} />
                <ModalBody fontSize="sm">
                    <Text>{translate('icg.modal.deleteInfo')}</Text>
                </ModalBody>

                <ModalFooter>
                    <Button
                        isDisabled={isDeleteInternationalCompanyGroupLoading}
                        variant="outline"
                        size="sm"
                        mr={3}
                        onClick={handleCloseDelete}
                    >
                        {translate('icg.modal.cancel')}
                    </Button>
                    <Button
                        onClick={intentionalyFloatingPromiseReturn(handleDeleteProductKeyword)}
                        isLoading={isDeleteInternationalCompanyGroupLoading}
                        colorScheme="red"
                        size="sm"
                    >
                        {translate('icg.modal.delete')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default DeleteModal;
